module.exports = __webpack_public_path__ + "img/105.9e63847e.jpg";